const e=Object.freeze({LOGIN:"LOGIN",REGISTRATION:"REGISTRATION"}),t="localhost",T=Object.freeze({HTTP:"http://",HTTPS:"https://"});export{e as IDENTITY_ACTIONS,t as LOCALHOST,T as PROTOCOLS};
//# sourceMappingURL=constants.js.map
